var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 630 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M622 106L311 417L0 106l65-65l246 245L556 41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoArrowDown);
export default __webpack_public_path__ + "static/media/infoArrowDown.b37da951ba7dcc47242856f6e527b1b0.svg";
export { ForwardRef as ReactComponent };